const isLoadingReducer = (state = false, action) => {
  switch (action.type) {
    case "LOADEROFF":
      return false;
    case "LOADERON":
      return true;
    default:
      return state;
  }
};

export default isLoadingReducer;
